import React, { useContext, useEffect, useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { EPCRContext } from '../EPCR'
import { Alert, Box, Button, Stack, Typography } from '@mui/material'

const Signature = ({ moduleName, field, title }) => {
  const { handleChange } = useContext(EPCRContext)
  const sigPadRef = useRef(null)
  const containerRef = useRef(null)
  const [hasSignature, setHasSignature] = useState(false)
  const [noSigAlert, setNoSigAlert] = useState(false)
  const [canvasWidth, setCanvasWidth] = useState(300)

  useEffect(() => {
    if (containerRef.current) {
      setCanvasWidth(containerRef.current.offsetWidth)
    }
  }, [])

  const clearSignature = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear()
      setHasSignature(false)
    }
  }

  const saveSignature = () => {
    if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
      const sigData = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL('image/png')
      handleChange({
        moduleName,
        field,
        value: sigData,
      })
    } else {
      setNoSigAlert(true)
    }
  }

  return (
    <Stack gap={1}>
      <Box ref={containerRef} height="200px" width="100%">
        <SignatureCanvas
          ref={sigPadRef}
          onEnd={() => setHasSignature(true)}
          penColor="black"
          canvasProps={{
            width: canvasWidth,
            height: 200,
            className: 'sigCanvas',
            style: {
              borderRadius: '4px',
              border: '1px solid #616161',
              boxShadow: '1px 1px 4px #616161',
              cursor: 'pointer',
            },
          }}
        />
      </Box>
      <Button
        fullWidth
        color="error"
        variant="contained"
        onClick={clearSignature}
        disabled={!hasSignature}
      >
        Clear
      </Button>
      <Button
        fullWidth
        color="success"
        variant="contained"
        onClick={saveSignature}
        disabled={!hasSignature}
      >
        Submit
      </Button>
    </Stack>
  )
}
export default Signature
